import { Box, Link, Typography } from '@mui/material';
import { FC, useEffect } from 'react';
import { Outlet, useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { link } from '../../../misc/globals';

export const Footer: FC = () => {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();

  useEffect(() => {
    if (lang) i18n.changeLanguage(lang);
  }, []);

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <Outlet />
      </Box>
      <Box
        sx={{
          textAlign: 'center',
          marginBottom: '2.25rem',
          '& a': {
            color: 'grey.700',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontFamily: 'Rubik',
            fontSize: '0.75rem'
          },
          paddingTop: 3,
          paddingX: 2,
          flexShrink: 0
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '2.25rem',
            justifyContent: 'center',
            marginBottom: '1rem'
          }}
        >
          <Link href={link.contact}>{t('account:CONTACT')}</Link>
          <Link href={link.imprint}>{t('account:IMPRESSUM')}</Link>
          <Link href={link.privacy_policy}>{t('account:DATA_PRIVACY')}</Link>
        </Box>
        <Typography variant="caption" color="primary.light" lineHeight="0.875rem">
          {t('account:COPYRIGHT', { year: new Date().getFullYear() })}
          <br />
          {t('account:LEGAL_INFORMATION_PART_1')}{' '}
          <Link href={link.privacy_policy}>{t('account:DATA_PRIVACY_POLICY')}</Link>{' '}
          {t('account:LEGAL_INFORMATION_PART_2')}{' '}
          <Link href={link.customer_agb}>{t('account:TERMS_OF_USE')}</Link>{' '}
          {t('account:LEGAL_INFORMATION_PART_3')}
        </Typography>
      </Box>
    </Box>
  );
};
